import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
// import Loader from 'components/Loader';
// import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
// import ElectionStatusCard from '../ElectionStatusCard';
import s from './LokSabhaElectionStateWrapper.scss';
// import AlliancePopup from '../../common/AlliancePopup';
import { loadLokSabhaElectionData } from '../../loksabha_redux';
import analyticsWrapper from '../../../../helpers/analytics/analyticsWrapper';
// import ExitPollStateWidget from '../ExitPollStateWidget/ExitPollStateWidget';
import ResultStateWidget from '../ResultStateWidget/ResultStateWidget';

class LokSabhaElectionStateWrapper extends React.Component {
  constructor(props) {
    super(props);
    try {
      this.state = {
        selectedSource: this.props?.sortedData?.selectedSource,
      };
      const { states = [] } = this.props;
      this.tabRefs = states.reduce((acc, tab) => {
        acc[tab.key] = React.createRef();
        return acc;
      }, {});
    } catch (error) {
      // Error Occurred
    }
  }

  componentDidMount() {
    const { isExitPoll } = this.props;
    if (!isExitPoll) {
      this.props.fetchElectionData({
        refreshinterval: this.props.refreshinterval,
        result: this.props.result,
        infoMsg: this.props.infoMsg,
        datasource: this.props.datasource,
        states: this.props.states,
      });
      this.refreshData();
    }
  }

  componentWillUnmount() {
    clearInterval(this.electionWidgetInterval);
  }

  refreshData = () => {
    const { refreshinterval } = this.props;
    if (refreshinterval) {
      this.electionWidgetInterval = setInterval(() => {
        this.props.fetchElectionData({
          refreshinterval: this.props.refreshinterval,
          result: this.props.result,
          infoMsg: this.props.infoMsg,
          datasource: this.props.datasource,
          states: this.props.states,
        });
      }, refreshinterval * 1000);
    }
  };

  handleSourceOnChange = e => {
    this.setState({ selectedSource: e });
    // eslint-disable-next-line no-nested-ternary
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'exitpoll_widget',
      category: this.props?.config?.name || 'Assembly Elections',
      label: e.name,
    });
  };

  render() {
    const {
      isWapView,
      isExitPoll,
      bgColor,
      bgColorOuter,
      states = [],
      datasource,
      sortedData,
      alMasterMap,
      prMasterMap,
      refreshinterval,
      sectionItem,
      infoMsg,
      starCandidateData,
      infoMsgCommon,
    } = this.props;

    const { electionkey } = sectionItem;

    const {
      // exitPollSource,
      finalSourceData,
    } =
      sortedData || {};

    // If the id is inactivated
    if (!refreshinterval) {
      return null;
    }

    const powerStates =
      states &&
      Array.isArray(states) &&
      states.filter(str => str.powerState === '1');

    // const { majority = 0, activeSeats = 0, sortedAlRslt = [], infoMsg = '' } =
    //   finalSourceData?.[this.state?.selectedSource?.name]?.states?.[
    //     electionkey
    //   ] || {};

    const lokSabhaStateMap = isExitPoll
      ? finalSourceData?.[this.state?.selectedSource?.name]?.states || {}
      : sortedData?.states || {};

    const lokSabhaStates = Object.values(lokSabhaStateMap) || [];
    const backGroundStyle = bgColor ? `#${bgColor}` : '';

    const backGroundStyleOuter = bgColorOuter ? `#${bgColorOuter}` : '';

    return (
      <div className={`${`election_widget`}`} ref={this.ref}>
        <div
          className={`${s.electionWidget} ${!isExitPoll ? s.result : ''}`}
          style={{ backgroundColor: backGroundStyleOuter }}
        >
          <div
            style={{ backgroundColor: backGroundStyle }}
            className={s.electionInner}
          >
            {!isExitPoll && (
              <ResultStateWidget
                powerStates={powerStates}
                lokSabhaStateMap={lokSabhaStateMap}
                lokSabhaStates={lokSabhaStates}
                sortedData={sortedData}
                infoMsg={infoMsg}
                isWapView={isWapView}
                datasource={datasource}
                alMasterMap={alMasterMap}
                prMasterMap={prMasterMap}
                stateName={electionkey}
                starCandidateData={starCandidateData}
                infoMsgCommon={infoMsgCommon}
              />
            )}
            {/* {isExitPoll && (
              <ExitPollStateWidget
                infoMsg={infoMsg}
                isWapView={isWapView}
                lokSabhaStates={lokSabhaStates}
                lokSabhaStateMap={lokSabhaStateMap}
                activeSeats={activeSeats}
                majority={majority}
                sortedAlRslt={sortedAlRslt}
                exitPollSource={exitPollSource}
                selectedSource={this.state.selectedSource}
                handleSourceOnChange={this.handleSourceOnChange}
                starCandidateData={starCandidateData}
              />
            )} */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refreshinterval: state?.lokSabhaElection?.refreshinterval,
  electionData: state?.lokSabhaElection?.electionData,
  isExitPoll: state?.lokSabhaElection?.isExitPoll,
  starCandidateData: state?.lokSabhaElection?.starCandidateData,
  displaytext: state?.lokSabhaElection?.displaytext,
  keywords: state?.lokSabhaElection?.keywords,
  breakingnews: state?.lokSabhaElection?.breakingnews,
  states: state?.lokSabhaElection?.states,
  liveblog: state?.lokSabhaElection?.liveblog,
  datasource: state?.lokSabhaElection?.datasource,
  hideexitheading: state?.lokSabhaElection?.hideexitheading,
  path: state?.lokSabhaElection?.path,
  shareTitle: state?.lokSabhaElection?.shareTitle,
  exitPollStateData: state?.lokSabhaElection?.exitPollStateData,
  sortedData: state?.lokSabhaElection?.sortedData,
  result: state?.lokSabhaElection?.result,
  infoMsg: state?.lokSabhaElection?.infoMsg,
  prMasterMap: state?.lokSabhaElection?.prMasterMap,
  alMasterMap: state?.lokSabhaElection?.alMasterMap,
});

const mapDispatchToProps = dispatch => ({
  fetchElectionData: data => {
    dispatch(loadLokSabhaElectionData(data));
  },
});

LokSabhaElectionStateWrapper.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
  isExitPoll: PropTypes.bool,
  // hideExitHeading: PropTypes.bool,
  bgColor: PropTypes.string,
  bgColorOuter: PropTypes.string,
  isPowerByAd: PropTypes.shape({}),
  // showDots: PropTypes.bool,
};
LokSabhaElectionStateWrapper.defaultProps = {
  isWapView: false,
  data: {},
  isExitPoll: false,
  // hideExitHeading: false,
  bgColor: '',
  bgColorOuter: '',
  isPowerByAd: null,
  // showDots: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  LokSabhaElectionStateWrapper,
);
